import base_ds from "@/services/base_datasource_service";
import request from "@/utils/request";
import { AxiosResponse } from "axios";
import { SaleTotal } from "./models-service";
import { exportToExcelFile } from "@/utils/excel";

export const route_ns = `sale_total`;

class SaleTotalService {
  public crud = base_ds.getBaseCrud(route_ns);

  public async getWithFilter(ids: String[], id_facility: number, periods: string[]): Promise<SaleTotal[]> {
    const url = `${route_ns}?filter=[["id_cut","in",${JSON.stringify(ids)}],"and",["id_eco_facility","=","${id_facility}"],"and",["month","in",${JSON.stringify(periods)}]]`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async getChanged(id_cut: string, id_facility: number, blocks: string[], periods: string): Promise<SaleTotal[]> {
    let is_total = `["block","in",${JSON.stringify(blocks)}]`;
    if (blocks.includes('total')) {
      is_total = `[["block","in",${JSON.stringify(blocks)}],"or",["is_total","=","true"]]`;
    }
    const url = `${route_ns}?filter=[["id_cut","=","${id_cut}"],"and",["id_eco_facility","=","${id_facility}"],"and",${is_total},"and",["month","in",${JSON.stringify(periods)}]]`;
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async save(pack: SaleTotal[]) {
    return await request({
      url: route_ns,
      method: "post",
      data: {data: pack},
    });
  }

  public async savePack(pack: SaleTotal[]) {
    try {
      pack.forEach(row => {
        this.crud.save(row);
      });
    } catch (err) {
      console.log(err);
    }
  }

  public async exportToExcel(data: any, filename: string | null = null) {
    await exportToExcelFile(data, route_ns, filename);
  }
}

export default new SaleTotalService();
